import Snackbar from 'vuejs-snackbar'

import data from './attrs/data'
import methods from './attrs/methods'
import mounted from './attrs/mounted'

export default {
    name: 'SymplaEventsList',
    data,
    methods,
    mounted,
    components: {
        Snackbar
    }
}
